import SbpsSubmitForm from '../../components/molecules/sbps/SbpsSubmitForm'
export default {
  components: { SbpsSubmitForm }
}
